const MeterIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2231_180790)">
        <path
          d="M10 13C10 13.5304 10.2107 14.0391 10.5858 14.4142C10.9609 14.7893 11.4696 15 12 15C12.5304 15 13.0391 14.7893 13.4142 14.4142C13.7893 14.0391 14 13.5304 14 13C14 12.4696 13.7893 11.9609 13.4142 11.5858C13.0391 11.2107 12.5304 11 12 11C11.4696 11 10.9609 11.2107 10.5858 11.5858C10.2107 11.9609 10 12.4696 10 13Z"
          stroke="#191414"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4502 11.55L15.5002 9.5"
          stroke="#191414"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.4 20.0002C4.93815 18.8382 3.87391 17.2504 3.35478 15.4566C2.83564 13.6629 2.88732 11.752 3.50265 9.98896C4.11797 8.22588 5.26647 6.69786 6.78899 5.61665C8.3115 4.53544 10.1326 3.95459 12 3.95459C13.8674 3.95459 15.6885 4.53544 17.211 5.61665C18.7335 6.69786 19.882 8.22588 20.4974 9.98896C21.1127 11.752 21.1644 13.6629 20.6452 15.4566C20.1261 17.2504 19.0619 18.8382 17.6 20.0002H6.4Z"
          stroke="#191414"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2231_180790">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MeterIcon
